import { h } from 'preact';
import clsx from 'clsx';
import { useEffect } from 'preact/hooks';
import { useDrawer } from '../drawer-context';
import BladeDrawer from './blade-drawer';
import HandleDrawer from './handle-drawer';
import HardwareDrawer from './hardware-drawer';
import FrontBackToggle from '../threekit-components/front-back-toggle';
import RandomizeButton from '../threekit-components/randomize-button';
import DrawerMobileBottomPanel from './drawer-mobile-bottom-panel';
import InspoButton from './inspo-button';
import BackgroundSelector from '../threekit-components/background-selector';
import HelpOverlayModal from './modals/help-overlay-modal';
import { useModal } from '../modal-context';
import InspoModal from './modals/inspo-modal';
import { useThreekit } from '../threekit-context';
import MobileToolbarModal from './modals/mobile-toolbar-modal';
import ErrorModal from './modals/error-modal';

function Drawer() {
  const { drawerName } = useDrawer();
  const { modalName } = useModal();
  const {
    darkMode,
    inspo,
    productTag,
    setBladeSide,
    knifeClickActive,
    errors,
  } = useThreekit();
  const isInspoModal = modalName === 'Inspo';
  const isToolbarModal = modalName === 'Mobile Toolbar';

  const hasInspirationObjects = inspo.some(
    (obj) => obj.customProductTag === productTag,
  );

  useEffect(() => {
    if (knifeClickActive) {
      return;
    }

    if (drawerName === 'Hardware') {
      setBladeSide('Back');
      return;
    }

    setBladeSide('Front');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerName]);

  if (!drawerName) {
    return null;
  }

  const handleSwitch = () => {
    switch (drawerName) {
    case 'Blade':
      return <BladeDrawer />;
    case 'Handle':
      return <HandleDrawer />;
    case 'Hardware':
      return <HardwareDrawer />;
    default:
      return null;
    }
  };

  const handleModalSwitch = () => {
    switch (modalName) {
    case 'Inspo':
      return <InspoModal />;
    case 'Mobile Toolbar':
      return <MobileToolbarModal />;
    default:
      return handleSwitch();
    }
  };

  return (
    <div
      className={clsx(
        'fixed flex flex-col bottom-0 right-0 w-full min-h-[142px] laptop:min-h-[156px] max-h-[222px] laptop:rounded-t-3xl',
        window.innerHeight < 570 ? 'max-h-[222px]' : 'max-h-[422px]',
        {
          'bg-bg-1': !darkMode,
          'bg-bg-2 bg-opacity-20': darkMode,
          'rounded-t-[10px]': isToolbarModal,
        },
      )}
    >
      <FrontBackToggle />
      <BackgroundSelector />
      <HelpOverlayModal />
      {!!Object.keys(errors).length && (
        <ErrorModal>{errors[Object.keys(errors)[0]]}</ErrorModal>
      )}
      <div
        className={clsx(
          'absolute top-[-50px] right-5 gap-4 items-stretch hidden laptop:flex',
          isInspoModal ? 'fixed' : 'absolute',
        )}
      >
        {hasInspirationObjects && <InspoButton />}
        <RandomizeButton />
      </div>
      {handleModalSwitch()}
      <DrawerMobileBottomPanel />
    </div>
  );
}

export default Drawer;
